import { render, staticRenderFns } from "./TenantForm.vue?vue&type=template&id=4dec9d40"
import script from "./TenantForm.vue?vue&type=script&lang=js"
export * from "./TenantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports